import twinToken from '@/assets/icons/twin-token.svg';
import FET_TOKEN_ABI from '@/constants/web3-constants/FETTokenABI.json';
import TWIN_TOKEN_ABI from '@/constants/web3-constants/TWINTokenABI.json';
import { AppConfigTypes } from "@/types/appConfigTypes";

export const web3Config =  (settings: AppConfigTypes | null) => ( {
  TWIN: {
    name: 'Twin Protocol',
    symbol: 'TWIN',
    ABI: TWIN_TOKEN_ABI,
    chains: {
      80002: settings?.suVariables?.twinContractAddress?.polygonTestnet,
      1: settings?.suVariables?.twinContractAddress?.ethMainnet,
    },
    icon: twinToken,
    buyUrl: `https://app.uniswap.org/swap?inputCurrency=ETH&outputCurrency=${settings?.suVariables?.twinContractAddress?.ethMainnet}`,
  },
  FET: {
    name: 'Artificial Superintelligence Alliance',
    ABI: FET_TOKEN_ABI,
    symbol: 'FET',
    chains: {
       80002: settings?.suVariables?.fetContractAddress?.polygonTestnet,
      1: settings?.suVariables?.fetContractAddress?.ethMainnet,
     },
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3773.png',
    buyUrl: `https://app.uniswap.org/swap?inputCurrency=ETH&outputCurrency=${settings?.suVariables?.fetContractAddress?.ethMainnet}`,
  },
})